module.exports = __webpack_public_path__ + "img/res3-m.8b063f29.png";